// ── Navigation ──────────────────────────────────
export const NAV_LINKS = [
  { id: "home",     label: "Home" },
  { id: "products", label: "Products" },
  { id: "services", label: "Services" },
  { id: "about",    label: "About Us" },
  { id: "demo",     label: "Demo" },
  { id: "contact",  label: "Contact" },
];

// ── Products ─────────────────────────────────────
export const PRODUCTS = [
  {
    id: "smartvision",
    name: "SmartVision AI™",
    tag: "Video Analytics",
    tagClass: "text-blue-600 bg-blue-50 border-blue-100",
    emoji: "🎥",
    iconBg: "from-blue-100 to-blue-50",
    accentColor: "#1e56d9",
    desc: "AI-powered video analytics for people counting, demographic profiling, heatmaps, and behavior monitoring across retail & malls.",
    longDesc:
      "AI-based video analytics platform for crowd counting, behavioral tracking, demographics, and heatmap analysis. Trusted by retailers and malls across Pakistan. Integrates seamlessly with your existing CCTV infrastructure.",
    features: [
      "Real-time people counting & crowd density",
      "Demographic profiling (age, gender, dwell time)",
      "Heatmap visualization of customer movement",
      "Behavior anomaly detection & alerts",
      "CCTV integration — no new hardware needed",
    ],
    stats: [
      { val: "2,847", label: "Daily Visitors",  chg: "+14.2%", up: true },
      { val: "4.2m",  label: "Avg Dwell Time",  chg: "+8.5%",  up: true },
      { val: "99%",   label: "AI Accuracy",      chg: "Stable", up: true },
      { val: "32%",   label: "Conversion Rate",  chg: "+3.1%",  up: true },
    ],
    live: "12 cameras active · Last sync 2s ago",
  },
  {
    id: "replenish",
    name: "ReplenishAI™",
    tag: "Inventory & ERP",
    tagClass: "text-orange-600 bg-orange-50 border-orange-100",
    emoji: "📦",
    iconBg: "from-orange-100 to-orange-50",
    accentColor: "#f57c00",
    desc: "ERP-integrated AI tool for auto-replenishment, seasonal planning, and demand forecasting. Eliminate stockouts with precision.",
    longDesc:
      "ERP-integrated AI tool for auto-replenishment, seasonal planning, and inventory forecasting. Reduce stockouts and minimize overstocking with precision demand prediction trained on your historical data.",
    features: [
      "AI demand forecasting by SKU",
      "Seasonal trend modeling & planning",
      "Auto purchase order generation",
      "ERP integration (SAP, Oracle, custom)",
      "Real-time inventory health dashboard",
    ],
    stats: [
      { val: "98%", label: "Order Accuracy",      chg: "+2.1%",   up: true },
      { val: "42%", label: "Stockout Reduction",  chg: "Improved",up: true },
      { val: "3.2x",label: "ROI Average",          chg: "+0.4x",   up: true },
      { val: "60d", label: "Avg Deploy Time",      chg: "Fast",    up: true },
    ],
    queue: [
      { name: "Men's Formals – L",  badge: "Low Stock",  cls: "bg-yellow-100 text-yellow-800" },
      { name: "Kids Footwear – 28", badge: "Ordered",    cls: "bg-green-100 text-green-800" },
      { name: "Summer Collection",  badge: "Forecasting",cls: "bg-blue-100 text-blue-800" },
    ],
  },
  {
    id: "retailiq",
    name: "RetailIQ™",
    tag: "Retail Intelligence",
    tagClass: "text-green-600 bg-green-50 border-green-100",
    emoji: "📊",
    iconBg: "from-green-100 to-green-50",
    accentColor: "#16a34a",
    desc: "Retail intelligence dashboard tracking ATV, UPT, footfall-to-sales conversion, peak hours, and product affinity in real time.",
    longDesc:
      "Retail analytics and intelligence dashboard providing insights into sales trends, customer patterns, and operational health. Track ATV, UPT, footfall conversion, and more across all your locations.",
    features: [
      "Average Transaction Value (ATV) tracking",
      "Units Per Transaction (UPT) analytics",
      "Footfall-to-sales conversion analysis",
      "Peak hour identification & staffing insights",
      "Multi-store performance comparison",
    ],
    kpiLabels: ["ATV", "UPT", "Conversion", "Footfall"],
  },
  {
    id: "auditapp",
    name: "AuditApp™",
    tag: "Field Operations",
    tagClass: "text-purple-600 bg-purple-50 border-purple-100",
    emoji: "📋",
    iconBg: "from-purple-100 to-purple-50",
    accentColor: "#9333ea",
    desc: "ERP-connected audit platform for retail, warehouse, and field operations with real-time syncing across mobile and web apps.",
    longDesc:
      "ERP-connected audit platform for retail, warehouse, and field operations. Real-time data syncing and reporting with intuitive mobile and web applications, built for on-the-ground teams.",
    features: [
      "Mobile-first design for field teams",
      "Compliance tracking & reporting",
      "Real-time ERP sync",
      "Offline mode with auto-sync",
      "Photo & video evidence capture",
    ],
    auditItems: [
      { label: "Store Compliance Check", pct: 94, color: "bg-purple-500" },
      { label: "Inventory Accuracy",     pct: 87, color: "bg-blue-500" },
      { label: "Display Standards",      pct: 76, color: "bg-orange-500" },
    ],
  },
];

// ── Services ──────────────────────────────────────
export const SERVICES = [
  {
    icon: "💡",
    title: "AI & Machine Learning",
    desc: "Predictive models, recommendation engines, anomaly detection, and intelligent automation tailored to your business data.",
    gradient: "from-blue-600 to-blue-500",
  },
  {
    icon: "🎥",
    title: "Computer Vision & Video Analytics",
    desc: "Analyze CCTV footage with AI for people counting, heatmaps, demographic profiling, and behavior detection.",
    gradient: "from-cyan-600 to-cyan-500",
  },
  {
    icon: "⚡",
    title: "Custom Software Development",
    desc: "Tailored applications built using modern frameworks and AI integrations — from concept to cloud.",
    gradient: "from-orange-600 to-orange-500",
  },
  {
    icon: "🔗",
    title: "Enterprise AI Integration",
    desc: "Embed AI into existing ERP, CRM, and business platforms for enhanced decision-making and automation.",
    gradient: "from-violet-600 to-violet-500",
  },
  {
    icon: "📱",
    title: "Mobile & Web Applications",
    desc: "Responsive, secure AI-enabled apps for Android, iOS, and web — built with performance in mind.",
    gradient: "from-emerald-600 to-emerald-500",
  },
  {
    icon: "📈",
    title: "Data Engineering & Analytics",
    desc: "Clean, process, and analyze large datasets to generate actionable business insights with live dashboards.",
    gradient: "from-red-600 to-red-500",
  },
];

// ── Industries ────────────────────────────────────
export const INDUSTRIES = [
  { 
    icon: "🛍️",
    name: "Retail & eCommerce",
    detail: "Footfall analytics, virtual try-ons, POS integrations, loyalty programs"
  },

  { 
    icon: "🏭",
    name: "Manufacturing",
    detail: "Predictive maintenance, quality control, production optimization"
  },

  { 
    icon: "🚚",
    name: "Supply Chain & Logistics",
    detail: "Inventory optimization, warehouse automation, demand forecasting"
  },

  { 
    icon: "💰",
    name: "Finance",
    detail: "Fraud detection, risk scoring, intelligent financial automation"
  }
];

// ── Testimonials ──────────────────────────────────
export const TESTIMONIALS = [
  {
    quote:
      "Eminent Solutions transformed our store operations with AI-powered insights. Their team is responsive, professional, and highly skilled. Sales increased by 35% and inventory management is now effortless.",
    name: "GM Sales & Marketing",
    role: "Chase Value",
    initials: "GM",
    stars: 5,
  },
  {
    quote:
      "The video analytics solution helped us monitor footfall and optimize staff deployment. The ROI was exceptional — we saw results within the first month of deployment. Great team to work with.",
    name: "Head of Operations",
    role: "Bacha Party",
    initials: "HO",
    stars: 5,
  },
  {
    quote:
      "ReplenishAI has completely revolutionized our supply chain. We reduced stockouts by 42% and our order accuracy is now above 98%. The ERP integration was completely seamless.",
    name: "Supply Chain Director",
    role: "Enterprise Retail Client",
    initials: "SC",
    stars: 5,
  },
];

// ── Why Choose Us ─────────────────────────────────
export const WHY_ITEMS = [
  { title: "Proven AI Expertise",       desc: "Deep experience deploying ML, computer vision, and NLP in enterprise environments." },
  { title: "MVP in 30–60 Days",         desc: "Agile execution with fast prototyping — from idea to production-ready product quickly." },
  { title: "Deep System Integration",   desc: "Seamlessly integrates with ERP, CRM, POS, IoT, CCTV, and your existing IT stack." },
  { title: "Long-Term Partnership",     desc: "Dedicated support from planning through deployment and ongoing optimization." },
];

// ── About Values ──────────────────────────────────
export const VALUES = [
  { icon: "💡", title: "Innovation First",  desc: "We push boundaries with AI and machine learning to solve problems others can't.",     bg: "from-blue-100 to-blue-50" },
  { icon: "🛡️", title: "Client Success",   desc: "Your success is our success. We measure ourselves by the outcomes we deliver.",       bg: "from-orange-100 to-orange-50" },
  { icon: "🤝", title: "Transparency",      desc: "Open communication, honest timelines, and clear project execution at every stage.",   bg: "from-green-100 to-green-50" },
  { icon: "⚡", title: "Speed & Agility",   desc: "MVP in 30–60 days. We execute fast without sacrificing quality or robustness.",       bg: "from-purple-100 to-purple-50" },
];

// ── Process Steps ─────────────────────────────────
export const PROCESS_STEPS = [
  { num: "01", title: "Discovery",          desc: "Understand your business, data, and objectives through collaborative workshops." },
  { num: "02", title: "Design & Prototype", desc: "Rapid prototyping and architecture design with continuous stakeholder feedback." },
  { num: "03", title: "Build & Train",      desc: "Agile development with AI model training, integration, and quality testing." },
  { num: "04", title: "Deploy",             desc: "Production deployment with monitoring, performance tracking, and team training." },
  { num: "05", title: "Optimize",           desc: "Continuous improvement with model retraining, performance analysis, and feature expansion." },
];

// ── Demo Videos ───────────────────────────────────
export const DEMO_VIDEOS = [
  {
    id: "v1",
    cat: "retail",
    product: "RetailIQ™",
    title: "RetailIQ™ Full Product Walkthrough",
    desc: "See how RetailIQ tracks ATV, UPT, and footfall-to-sales conversion in real time across multiple store locations.",
    duration: "4:32 min",
    tagClass: "bg-blue-600/70",
    gradient: "from-slate-900 to-blue-950",
  },
  {
    id: "v2",
    cat: "erp",
    product: "ReplenishAI™",
    title: "ReplenishAI™ Auto-Replenishment Demo",
    desc: "Watch how ReplenishAI integrates with SAP to generate automatic purchase orders based on AI demand forecasting.",
    duration: "6:14 min",
    tagClass: "bg-orange-600/70",
    gradient: "from-orange-950 to-orange-800",
  },
  {
    id: "v3",
    cat: "vision",
    product: "SmartVision AI™",
    title: "SmartVision AI™ Live Analytics",
    desc: "See how SmartVision analyzes CCTV footage in real time to deliver people counting, heatmaps, and behavioral insights.",
    duration: "5:08 min",
    tagClass: "bg-emerald-600/70",
    gradient: "from-emerald-950 to-teal-900",
  },
];

// ── Demo filter tabs ───────────────────────────────
export const DEMO_FILTERS = [
  { id: "all",    label: "All Products" },
  { id: "retail", label: "Retail Intelligence" },
  { id: "erp",    label: "ERP Solutions" },
  { id: "vision", label: "AI Vision" },
];

// ── Contact service options ────────────────────────
export const SERVICE_OPTIONS = [
  "Select a service...",
  "SmartVision AI™ (Video Analytics)",
  "ReplenishAI™ (Inventory)",
  "RetailIQ™ (Retail Analytics)",
  "AuditApp™ (Field Operations)",
  "Custom AI Development",
  "Enterprise Integration",
  "General Inquiry",
];

// ── Tech stack ────────────────────────────────────
export const TECH_STACK = ["Python AI/ML", "OpenCV", "React", "Node.js", "ERP APIs", "Cloud Native"];

// ── Hero weekly bars ──────────────────────────────
export const HERO_BARS = [
  { day: "Mon", pct: 78,  orange: false },
  { day: "Tue", pct: 92,  orange: false },
  { day: "Wed", pct: 65,  orange: false },
  { day: "Thu", pct: 88,  orange: true  },
  { day: "Fri", pct: 96,  orange: true  },
];
